import LinkedLabelValuePair from "@/models/LinkedLabelValuePair";
import axiosHelper from "../axiosHelper";

export default class JobComponentGroupsApiHelper {

	_url: string = '/api/servicejobcomponentgroups';

	async getRelatedJobIdsAsync(jwt: string, componentGroupId: number): Promise<Array<number> | null> {
		try {
			const jobCategoriesHttpClient = axiosHelper.createInstance(jwt);
			const jobCategoriesResponse = await jobCategoriesHttpClient.get(`${this._url}/rels/${componentGroupId}`);
			return jobCategoriesResponse.data.map((_: number) => _);
		} catch (e) {			
			console.error(`Error checking component-group #${componentGroupId} for related jobs`, e);
			return null;
		}
	}

	async deleteJobComponentGroupAsync(jwt: string, componentGroupId: number): Promise<boolean> {
		try {
			const jobOperationsHttpClient = axiosHelper.createInstance(jwt);
			await jobOperationsHttpClient.delete(`${this._url}/${componentGroupId}`);
			return true;
		} catch (e) {			
			console.error(`Error deleting service-job-component-group #${componentGroupId}`, e);
			return false;
		}
	}

	async getComponentGroupsTreeAsync(jwt: string) : Promise<Array<LinkedLabelValuePair<string, number>> | null> {
		
		const mapGroupsTree = (data: Array<any>) => {			
			return data.map((g: any) => {
				const group = new LinkedLabelValuePair<string, number>({				
					label: g.name,
					value: g.id
				});
				if (!g?.childGroups?.length) {
					group.children = undefined;
				} 
				else {
					group.children = mapGroupsTree(g.childGroups);
				}
				
				return group;
			});
		}

		try {
			const jobCategoriesHttpClient = axiosHelper.createInstance(jwt);
			const response = await jobCategoriesHttpClient.get(this._url);

			if (!response?.data) {
				return [];
			}

			return mapGroupsTree(response.data);
		}
		catch(e: any) {			
			console.error('Error loading job-components-groups list', e)
			return null;
		}
	}
}